export default __webpack_public_path__ + "static/media/bnr2.c2df322f.jpg";